module.exports = __webpack_public_path__ + "static/media/gp.d434f10b.png";